@if (result[trendDimension][0].series.length <= 1) {
  <div class="no-data-notice">
    {{ 'We’ll show you a trend chart here once 2 or more audits are performed.' | translate }}
  </div>
  <img src="/assets/img/chart-no-data.svg" alt="" />
} @else {
  <div #chartContainer>
    <ngx-charts-area-chart-stacked
      [view]="[chartContainer.clientWidth, 200]"
      [scheme]="getColorScheme()"
      [xAxis]="true"
      [yAxis]="true"
      [yScaleMax]="trendDimension === 'Score' ? 10 : undefined"
      [yScaleMin]="trendDimension === 'Score' ? 1 : undefined"
      [schemeType]="trendDimension === 'Score' ? 'linear' : 'ordinal'"
      [results]="result ? result[trendDimension] : []"
      [xAxisTickFormatting]="dateTickFormatting"
      [yAxisTickFormatting]="valueTickFormatting"
      (select)="onSelect($event)"
      >
      <ng-template #tooltipTemplate let-model="model">
        <div class="ngx-tooltip">
          <div class="timestamp">{{ formatPeriodId(model.name) }}</div>
          <div class="series-step-info">
            @if (model.series !== 'Score') {
              <span
                class="color"
                [class.at-risk]="model.series === 'At-Risk'"
                [class.lost]="model.series === 'Lost'"
              ></span>
            }
            <span class="series-name">{{ model.series | translate }}:</span>
            <span class="series-value">
              {{ valueTickFormatting(model.value) }}
            </span>
          </div>
        </div>
      </ng-template>
      <ng-template #seriesTooltipTemplate let-model="model">
        <div class="ngx-tooltip">
          <div class="timestamp">{{ formatPeriodId(model[0].name) }}</div>
          @for (d of model.slice().reverse(); track d) {
            <div class="series-step-info">
              @if (model.series !== 'Score') {
                <span
                  class="color"
                  [class.at-risk]="d.series === 'At-Risk'"
                  [class.lost]="d.series === 'Lost'"
                ></span>
              }
              <span class="series-name">{{ d.series | translate }}:</span>
              <span class="series-value">
                {{ valueTickFormatting(d.value) }}
              </span>
            </div>
          }
        </div>
      </ng-template>
    </ngx-charts-area-chart-stacked>
  </div>
}
